import React from 'react';
import cls from 'classnames';

import { NavLink } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

interface BreadcrumbsProps {
  paths?:
    | { icon?: string | React.ReactNode; href?: string; text?: string | React.ReactNode }[]
    | null;
}

export default function Breadcrumbs({ paths = [] }: BreadcrumbsProps) {
  const { t } = useTranslation();
  return (
    <ol
      className='flex flex-wrap items-center whitespace-nowrap min-w-0 gap-x-1.5'
      aria-label={t('Breadcrumb')}
    >
      <li className='text-sm'>
        <NavLink
          to='/'
          className='flex transition-all duration-300 items-center gap-x-1.5 text-gray-500 dark:text-[#747474]  hover:text-blue-600 dark:hover:brightness-75'
        >
          <Trans
            i18nKey='<i/> Home <arrow />'
            components={{
              i: <i className='icon-home' />,
              arrow: <i className='icon-angle-right text-xs' />,
            }}
          />
        </NavLink>
      </li>
      {paths?.map((item, idx) => (
        <li
          key={'breadcrumbs_' + idx}
          className={'text-sm text-gray-500 flex gap-x-1.5 items-center'}
        >
          <NavLink
            to={item.href ? item.href : '#'}
            end
            className={({ isActive }) =>
              cls(
                'flex transition-all duration-300 items-center hover:text-blue-600 dark:hover:brightness-75',
                isActive ? 'text-blue-500 dark:text-[#FFDA68]/90' : 'dark:hover:text-[#747474] ',
              )
            }
          >
            {item.icon}
            {item.text}
          </NavLink>

          {idx !== paths.length - 1 && <i className='icon-angle-right text-xs' />}
        </li>
      ))}
    </ol>
  );
}
